<form id="payment-form" (ngSubmit)="onSubmit()">
  <vnm-card-title header="stripe-payment.header"></vnm-card-title>
  <div id="link-authentication-element">
    <!-- Stripe.js injects the Link Authentication Element-->
  </div>
  <div #paymentElement id="payment-element">
    <!-- Stripe.js injects the Payment Element-->
  </div>
  <button #submitButton id="submit">
    <div class="spinner hidden" id="spinner"></div>
    <span
      id="button-text"
      [textContent]="'checkout.pay-now' | translate: { amount: shoppingCart.expectedTotal | currency }"
    ></span>
  </button>
</form>

<vnm-ably-channel-subscription
  [channel]="paymentChannel"
  (errorEvent)="handleError($event)"
  (completionEvent)="handleSuccess(order)"
></vnm-ably-channel-subscription>
